import React, { useState, Fragment, useEffect, createContext, useRef, useCallback } from 'react';
import { useForm, useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { useStyle } from './style';
import {
    Paper, Grid,
    TextField, FormControlLabel,
    Checkbox, FormLabel,
    Box, InputAdornment,
    Tooltip, IconButton,
    Typography, FormControl,
    RadioGroup, Radio,
    Select, MenuItem, InputLabel
} from '@material-ui/core';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import { masterData } from './data';
import errormesages from './errormessages';
export default function EirCustomerMobileDetails(props) {
    const classes = useStyle();
    const { register, errors, control, setError, clearError, setValue, getValues } = useFormContext();
    const { validation } = errormesages;

    const custMobilePrefixInputRef = useRef();
    const custMobileEirPhoneNoInputRef = useRef();
    const custMobileNetworkProviderInputRef = useRef();
    const custMobilePaymentTypeInputRef = useRef();
    const registeredMobileNetworkInputRef = useRef();
    const custMobileEirAccountNoInputRef = useRef();
    const onlyAccountNumberInputRef = useRef();
    const mobileDirectoryEnquiryInputRef = useRef();
    const keepMobileNumberInputRef=useRef();
    const [areaCode, setAreaCode] = useState(null);
    const [prefix, setPrefix] = useState(null);
    const [accNo, setAccNo] = useState(null);
    const [showBillPay, setShowBillPay] = useState(false);
    const [showPrePay, setShowPrePay] = useState(false);
    const [registeredNetwork, setRegisteredNetwork] = useState(false);
    const [onlyAccNumber, setOnlyAccNumber] = useState(false);
    const [existingAccount, setExistingAccount] = useState(false);
    const [showMobileDetails, setShowMobileDetails] = useState(false);

    // useEffect(() => {
    //     if (!areaCode) {
    //         let areaCodes = '/json/areacodes.txt';
    //         fetch(areaCodes)
    //             .then((response) => {
    //                 return response.json()
    //             })
    //             .then((data) => {
    //                 setAreaCode(data.areacodes);
    //             })
    //             .catch((err) => {
    //                 console.log(">>>>>>>Error in fetching the areacodes - ", err);
    //             })
    //     }
    // }, [prefix]);

    return (
        <Fragment>
            <Grid item sm={12} className={classes.mobilePadding}>
                <Paper className={classes.contactPaper} variant='elevation' elevation={4}>
                    <Grid container>
                        <Grid item sm={6}>
                            <Grid container>
                                <Grid item sm={7}>
                                    <h2 className={classes.contactTxt}>
                                        Mobile Details
                                    </h2>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <Typography className={classes.reqTextMobileDetails}><span style={{ color: 'red', textAlign: 'center' }} >*</span> Required Fields</Typography>
                        </Grid>
                    </Grid>
                    {props.showSIMOMobileDetails?
                        <Grid container sm={12} xs={12}>
                        {/* <Grid item sm={6} xs={12} md={12} className={classes.iconSimBlackLight}> */}
                        <Grid container sm={12} xs={12}>
                            <Grid sm={1} xs={2}>
                                <div className={classes.iconSimBlackLight}/>
                            </Grid>
                            <Grid sm={4} xs={9} className={classes.personalLabel}>
                                <Typography className={classes.iconSimBlackText}>{props.SIMOName}</Typography>
                            </Grid>                            
                        </Grid>
                        <Grid item sm={6} className={classes.paddingRightItem}>
                        <Grid>
                            <Typography className={classes.personalLabel}>Would you like to keep your mobile number?<span style={{ color: 'red', textAlign: 'center' }} > *</span></Typography>
                        </Grid>
                        <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                            <Controller
                                control={control}
                                name="keepMobileNumber"
                                id="keepMobileNumber"
                                inputRef={keepMobileNumberInputRef}
                                defaultValue=""
                                rules={{ required: { value: true, message: validation.keepMobileNumber } }}
                                error={Boolean(errors.keepMobileNumber)}
                                as={
                                    <RadioGroup aria-label="paymentType" name="keepMobileNumber" id='keepMobileNumber'
                                        className={classes.radioButton}>
                                        <Grid container>
                                            <Grid item>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" className={classes.personalLabel} />
                                            </Grid>
                                            <Grid item>
                                                <FormControlLabel value="false" control={<Radio />} label="No" className={classes.personalLabel} />
                                            </Grid>
                                        </Grid>
                                    </RadioGroup>
                                }
                                onChange={([event]) => {
                                    if (event.target.value === "true") {
                                        setShowMobileDetails(true);                                        
                                    }
                                    else {
                                        setShowMobileDetails(false);                                        
                                    }
                                    return event.target.value;
                                }}
                            />
                            <ErrorMessage errors={errors} name='keepMobileNumber'>
                                {({ message }) => <p className={classes.errorMessageMobile}>{message}</p>}
                            </ErrorMessage>
                        </FormControl>
                    </Grid>
                        {showMobileDetails?
                            <Grid item sm={6} xs={12} md={12} className={classes.personalLabel}>
                                <Typography>Customers who do not port their number within 30 days of purchase will be liable to pay eir the relevant porting discount on their next bill.</Typography>
                            </Grid>
                        :''}                        
                    </Grid>
                    :''}
                    {showMobileDetails || props.showEirCustomerMobileDetails?
                    <Grid>                      
                    
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormLabel className={classes.formMobileLabelColor}>What number do you want to move to eir Mobile?</FormLabel>
                        </Grid>
                    </Grid>

                    <Grid container sm={12} xs={12} md={12}>
                        <Grid container spacing={2}>
                            <Grid item sm={2} xs={4} md={1} className={classes.accountMobilePrefix}>
                                <FormControl variant="outlined" fullWidth size="small" color="secondary" className={classes.dropDownMinWidth}>
                                    <InputLabel required
                                        error={Boolean(errors.custMobilePrefix)}
                                    >Prefix</InputLabel>
                                    <Controller
                                        control={control}
                                        name="custMobilePrefix"
                                        id="custMobilePrefix"
                                        inputRef={custMobilePrefixInputRef}
                                        defaultValue=""
                                        error={Boolean(errors.custMobilePrefix)}
                                        onFocus={() => {
                                            custMobilePrefixInputRef.current.focus();
                                        }}
                                        rules={{ required: { value: true, message: validation.custMobilePrefix } }}
                                        as={
                                            <Select
                                                id="custMobilePrefix"
                                                label="Prefix"
                                            >
                                                {/* {areaCode ? areaCode.map((code) =>
                                                    <MenuItem key={code.code} value={code.code} className={classes.selectLabel}>
                                                        {code.code}
                                                    </MenuItem>
                                                ) : ''} */}

                                                {masterData.filter(masterData => masterData.id === 'prefixProvider').map((data) =>
                                                    data.value.map((val) =>
                                                    (
                                                        <MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
                                                            {val.label}
                                                        </MenuItem>
                                                    ))
                                                )}
                                            </Select>
                                        }
                                        onChange={([event]) => {
                                            setPrefix(event.target.value);
                                            return event.target.value;
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item sm={4} xs={8} md={3} className={classes.mobileDetailPaddingRight}>
                                <Controller
                                    as={<TextField inputRef={custMobileEirPhoneNoInputRef} color="secondary" />}
                                    control={control}
                                    fullWidth
                                    id="custMobileEirPhoneNo"
                                    name="custMobileEirPhoneNo"
                                    label="Phone number"
                                    variant="outlined"
                                    size="small"
                                    error={Boolean(errors.custMobileEirPhoneNo)}
                                    onFocus={() => {
                                        custMobileEirPhoneNoInputRef.current.focus();
                                    }}
                                    required
                                    rules={{
                                        required: { value: true, message: validation.custMobileEirPhoneNo },
                                        pattern: { value: /^[0-9]{7}$/, message: validation.phoneNumberPattern }
                                    }}
                                    onChange={([event]) => {
                                        // getCmsCheck();
                                        return event.target.value;
                                    }}
                                />
                                {errors.prefix ?
                                    <Grid className={classes.errorMessageHeight}>
                                        <ErrorMessage errors={errors} name='custMobilePrefix'>
                                            {({ message }) => <p className={classes.errorMessageCustMobile}>{message}</p>}
                                        </ErrorMessage>
                                    </Grid>
                                    :
                                    <Grid className={classes.errorMessageHeight}>
                                        <ErrorMessage errors={errors} name="custMobileEirPhoneNo">
                                            {({ message }) => <p className={classes.errorMessageCustMobile}>{message}</p>}
                                        </ErrorMessage>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={6} xs={12} className={classes.paddingRightItem}>
                        <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                            <InputLabel required
                            >Your current Network provider</InputLabel>
                            <Controller
                                control={control}
                                name="custMobileNetworkProvider"
                                id="custMobileNetworkProvider"
                                inputRef={custMobileNetworkProviderInputRef}
                                defaultValue=""
                                rules={{ required: { value: true, message: validation.custMobileNetworkProvider } }}
                                error={Boolean(errors.custMobileNetworkProvider)}
                                onFocus={() => {
                                    custMobileNetworkProviderInputRef.current.focus();
                                }}
                                as={
                                    <Select
                                        id='custMobileNetworkProvider'
                                        label="Your current Network provider"
                                    >
                                        {masterData.filter(masterData => masterData.id === 'mobileNetworkProvider').map((data) =>
                                            data.value.map((val) =>
                                            (
                                                <MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
                                                    {val.label}
                                                </MenuItem>
                                            ))
                                        )}
                                    </Select>
                                }
                                onChange={([event]) => {
                                    //changeProvider(event.target.value);
                                    return event.target.value;
                                }}
                            />
                            <Grid className={classes.errorMessageHeight}>
                                <ErrorMessage errors={errors} name='custMobileNetworkProvider'>
                                    {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                </ErrorMessage>
                            </Grid>
                        </FormControl>
                    </Grid>

                    <Grid item sm={6} className={classes.paddingRightItem}>
                        <Grid>
                            <Typography className={classes.personalLabel}>Payment type<span style={{ color: 'red', textAlign: 'center' }} > *</span></Typography>
                        </Grid>
                        <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                            <Controller
                                control={control}
                                name="custMobilePaymentType"
                                id="custMobilePaymentType"
                                inputRef={custMobilePaymentTypeInputRef}
                                defaultValue=""
                                rules={{ required: { value: true, message: validation.custMobilePaymentType } }}
                                error={Boolean(errors.custMobilePaymentType)}
                                onFocus={() => {
                                    custMobileNetworkProviderInputRef.current.focus();
                                }}
                                as={
                                    <RadioGroup aria-label="paymentType" name="custMobilePaymentType" id='custMobilePaymentType'
                                        className={classes.radioButton}>
                                        <Grid container>
                                            <Grid item>
                                                <FormControlLabel value="BILLPAY" control={<Radio />} label="Billpay" className={classes.personalLabel} />
                                            </Grid>
                                            <Grid item>
                                                <FormControlLabel value="PREPAY" control={<Radio />} label="Prepay" className={classes.personalLabel} />
                                            </Grid>
                                        </Grid>
                                    </RadioGroup>
                                }
                                onChange={([event]) => {
                                    if (event.target.value === "BILLPAY") {
                                        setShowBillPay(true);
                                        setShowPrePay(false)
                                    }

                                    else {
                                        setShowBillPay(false);
                                        setShowPrePay(true)
                                    }

                                    return event.target.value;
                                }}
                            />
                            <ErrorMessage errors={errors} name='custMobilePaymentType'>
                                {({ message }) => <p className={classes.errorMessageMobile}>{message}</p>}
                            </ErrorMessage>
                        </FormControl>
                    </Grid>
                    {showBillPay &&
                        <Grid item sm={6} xs={12} className={classes.paddingRightItem}>
                            <Controller
                                as={<TextField color="secondary" />}
                                inputRef={custMobileEirAccountNoInputRef}
                                control={control}
                                fullWidth
                                id="custMobileEirAccountNo"
                                name="custMobileEirAccountNo"
                                label="Your existing account number"
                                InputLabelProps={(accNo) && { shrink: true }}
                                variant="outlined"
                                size="small"
                                error={Boolean(errors.custMobileEirAccountNo)}
                                onFocus={() => {
                                    custMobileEirAccountNoInputRef.current.focus();
                                }}
                                required
                                rules={{
                                    required: { value: true, message: validation.custMobileEirAccountNo },
                                    pattern: { value: /^[0-9]*$/, message: validation.custMobileEirAccountNo },
                                    // maxLength: { value: 8, message: validation.custMobileEirAccountNo }
                                }}
                                onChange={([event]) => {
                                    // handleaccNum(event);
                                    // getCmsCheck();
                                    return event.target.value;
                                }}
                            />
                            <Grid className={classes.errorMessageHeight}>
                                <ErrorMessage errors={errors} name="custMobileEirAccountNo">
                                    {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                </ErrorMessage>
                            </Grid>
                        </Grid>
                    }
                    {showPrePay &&
                        <Grid item sm={6} className={classes.paddingRightItem}>
                            <Grid>
                                <Typography className={classes.personalLabel}>Are you registered with your Network? <span style={{ color: 'red', textAlign: 'center' }} > *</span></Typography>
                            </Grid>
                            <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                                <Controller
                                    control={control}
                                    name="registeredMobileNetwork"
                                    id="registeredMobileNetwork"
                                    inputRef={registeredMobileNetworkInputRef}
                                    defaultValue=""
                                    rules={{ required: { value: true, message: validation.registeredMobileNetwork } }}
                                    error={Boolean(errors.registeredMobileNetwork)}
                                    onFocus={() => {
                                        custMobileNetworkProviderInputRef.current.focus();
                                    }}
                                    as={
                                        <RadioGroup aria-label="registeredMobileNetwork" name="registeredMobileNetwork" id='registeredMobileNetwork'
                                            className={classes.radioButton}>
                                            <Grid container>
                                                <Grid item>
                                                    <FormControlLabel value="true" control={<Radio />} label="Yes" className={classes.personalLabel} />
                                                </Grid>
                                                <Grid item>
                                                    <FormControlLabel value="false" control={<Radio />} label="No" className={classes.personalLabel} />
                                                </Grid>
                                            </Grid>
                                        </RadioGroup>
                                    }
                                    onChange={([event]) => {
                                        (event.target.value === "true") ? setRegisteredNetwork(true) : setRegisteredNetwork(false);
                                        return event.target.value;
                                    }}
                                />
                                <ErrorMessage errors={errors} name='registeredMobileNetwork'>
                                    {({ message }) => <p className={classes.errorMessageMobile}>{message}</p>}
                                </ErrorMessage>
                            </FormControl>
                        </Grid>
                    }


                    {(showBillPay || registeredNetwork) &&
                        <Grid item sm={6} className={classes.paddingRightItem}>
                            <Grid>
                                <Typography className={classes.personalLabel}>Is this the only number on this account? <span style={{ color: 'red', textAlign: 'center' }} > *</span></Typography>
                            </Grid>
                            <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                                <Controller
                                    control={control}
                                    name="onlyAccountNumber"
                                    id="onlyAccountNumber"
                                    inputRef={onlyAccountNumberInputRef}
                                    defaultValue=""
                                    rules={{ required: { value: true, message: validation.onlyAccountNumber } }}
                                    error={Boolean(errors.onlyAccountNumber)}
                                    onFocus={() => {
                                        custMobileNetworkProviderInputRef.current.focus();
                                    }}
                                    as={
                                        <RadioGroup aria-label="onlyAccountNumber" name="onlyAccountNumber" id='onlyAccountNumber'
                                            className={classes.radioButton}>
                                            <Grid container>
                                                <Grid item>
                                                    <FormControlLabel value="false" control={<Radio />} label="Yes" className={classes.personalLabel} />
                                                </Grid>
                                                <Grid item>
                                                    <FormControlLabel value="true" control={<Radio />} label="No" className={classes.personalLabel} />
                                                </Grid>
                                            </Grid>
                                        </RadioGroup>
                                    }

                                />
                                <ErrorMessage errors={errors} name='onlyAccountNumber'>
                                    {({ message }) => <p className={classes.errorMessageMobile}>{message}</p>}
                                </ErrorMessage>
                            </FormControl>
                        </Grid>
                    }

                    <Grid item sm={6} className={classes.paddingRightItem}>
                        <Grid>
                            <Typography className={classes.personalLabel}>Would you like your mobile to be listed in the directory enquiries? <span style={{ color: 'red', textAlign: 'center' }} > *</span></Typography>
                        </Grid>
                        <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                            <Controller
                                control={control}
                                name="mobileDirectoryEnquiry"
                                id="mobileDirectoryEnquiry"
                                inputRef={mobileDirectoryEnquiryInputRef}
                                defaultValue=""
                                rules={{ required: { value: true, message: validation.mobileDirectoryEnquiry } }}
                                error={Boolean(errors.mobileDirectoryEnquiry)}
                                onFocus={() => {
                                    custMobileNetworkProviderInputRef.current.focus();
                                }}
                                as={
                                    <RadioGroup aria-label="mobileDirectoryEnquiry" name="mobileDirectoryEnquiry" id='mobileDirectoryEnquiry'
                                        className={classes.radioButton}>
                                        <Grid container>
                                            <Grid item>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" className={classes.personalLabel} />
                                            </Grid>
                                            <Grid item>
                                                <FormControlLabel value="false" control={<Radio />} label="No" className={classes.personalLabel} />
                                            </Grid>
                                        </Grid>
                                    </RadioGroup>
                                }

                            />
                            <ErrorMessage errors={errors} name='mobileDirectoryEnquiry'>
                                {({ message }) => <p className={classes.errorMessageMobile}>{message}</p>}
                            </ErrorMessage>
                        </FormControl>
                    </Grid>
                    </Grid>                    
                    :''}
                </Paper>
            </Grid>
        </Fragment>
    );
}